import { FC, useMemo } from "react";
import cn from "classnames";
import { createSeaEvents } from "features/shared/OpenedCardEvents/utils";
import { SeaSearchCardModel } from "entities/SeaSearchCard";
import { Nullable } from "shared/lib/typeCheck.lib";
import { useTranslation } from "shared/localization/localization";
import styles from "./EventList.module.scss";

import { Event } from "../Event";

type EventListProps = {
  className?: string;
  data: Nullable<SeaSearchCardModel>;
};

export const EventList: FC<EventListProps> = ({ data, className }) => {
  const { t } = useTranslation();

  const eventEntries = useMemo(() => createSeaEvents(data?.getTransformedEvents(data?.events)), [data?.rawData]);

  const hasEventEntries = eventEntries.length > 0;

  const errorMessage = data?.searchErrorText("Route is not available at the moment") ?? "";

  return (
    <div className={cn(styles.eventList, !hasEventEntries && styles.notAvailable, className)}>
      {hasEventEntries ? (
        eventEntries.map((eventEntry, eventEntryIndex) => {
          const isLastEvent = eventEntries.length - 1 === eventEntryIndex;

          return <Event key={eventEntryIndex} eventEntry={eventEntry} isLastEvent={isLastEvent} />;
        })
      ) : (
        <>
          <div className={styles.notAvailableBold}>{t(errorMessage)}.</div>
          <div className={styles.notAvailableNormal}>{t("Please, try again later")}.</div>
        </>
      )}
    </div>
  );
};
